import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BaseService as __BaseService } from '../../../services/api-client/base-service';
import { ApiConfiguration as __Configuration } from '../../../services/api-client/api-configuration';
import { saveAs } from 'file-saver';
import { CvDto } from '../../../services/api-client/models/cv-dto';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CvService extends __BaseService {

  constructor(
    http: HttpClient,
    config: __Configuration,
    private translate: TranslateService,
    private toastrService: ToastrService
  ) {
    super(config, http);
  }

  downloadDocX(cv: CvDto): void {
    const fileUrl = environment.apiURL + '/api/v1/cv/' + cv.id + '/export';
    this.http.get(fileUrl, {responseType: 'blob'})
      .subscribe((blob: Blob): void => {
        saveAs(blob, cv.name + '.docx');
      }, error => {
        this.translate.get('download_error').subscribe(txt => {
          this.toastrService.error(txt + ': ' + cv.name)
        });
        console.log('Error! Failed to download CV', error);
      });
  }
}
